import { Navigate } from 'react-router-dom';
import { useAuth } from '../../common/auth';
import { HOME, INACTIVE_USER } from '../../config/routes';

/**
 * AdminRoute component to protect routes that require admin privileges.
 * @param children - The component to render if the user is an admin.
 * @returns The child component if the user is an admin, otherwise redirects to the home page.
 */
function AdminRoute({ children }: { children: JSX.Element }) {
  // Destructure the isAdmin property from the authentication hook
  const { isAdmin, isActive } = useAuth();

  if (!isAdmin) {
    // If the user is not an admin, redirect to the home page
    return <Navigate to={HOME} />;
  }

  // If the users account is disabled, redirect to the inactive page
  if (!isActive) {
    return <Navigate to={INACTIVE_USER} />;
  }

  // If the user is an admin, render the child component
  return children;
}

export default AdminRoute;
